import React, { Component } from "react";
import PropTypes from "prop-types";

import { Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";
import { Input } from "formsy-react-components";

import Map from "../../common/Map";
import DropdownSearch from "../../common/DropdownSearch";
import PhoneNumberInput from "../../common/PhoneNumberInput";

class CustomerLocationForm extends Component {
  constructor(props) {
    super(props);
    this.state = { canSubmit: false };
  }

  onChange = (field, selected) => {
    this.setState({ [field]: selected.value });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  add = (model) => {
    this.props.onAdd(model);
  };

  submit = (model) => {
    model.id = this.props.location._id;
    this.props.onSave(model);
  };

  cancel = () => {
    this.props.onCancel();
  };

  render() {
    const { location, adding, editing, saving } = this.props;

    location.address = location.address || {};

    return (
      <Formsy
        className="vertical form"
        onValidSubmit={adding ? this.add : this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
      >
        <Row>
          <Col md={6} xs={6}>
            <Input
              required
              name="name"
              label="Name"
              placeholder="Name"
              value={location.name}
              validations={{ maxLength: 250 }}
              validationErrors={{
                maxLength: "You can not type in more than 250 characters"
              }}
            />
          </Col>
          <Col md={6} xs={6}>
            <DropdownSearch
              name="location_type"
              label="Location Type"
              value={this.state.location_type || location.location_type}
              disabled={!editing}
              onChange={this.onChange}
              data={this.props.codes
                .filter(
                  (codes) =>
                    codes.entity === "Location" &&
                    codes.field === "location_type"
                )
                .map((code) => ({
                  value: code.id,
                  label: code.label
                }))}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} xs={6}>
            <PhoneNumberInput
              name="phone"
              label="Phone"
              placeholder="Phone"
              value={location.phone}
              disabled={!editing}
            />
          </Col>
          <Col md={6} xs={6}>
            <PhoneNumberInput
              name="fax"
              label="Fax"
              placeholder="Fax"
              value={location.fax}
              disabled={!editing}
            />
          </Col>
          <Col md={4} xs={12}>
            <Input
              required
              name="address.addr1"
              label="Address 1"
              placeholder="Address 1"
              value={location.address.addr1}
              validations={{ maxLength: 250 }}
              validationErrors={{
                maxLength: "You can not type in more than 250 characters"
              }}
            />
          </Col>
          <Col md={4} xs={12}>
            <Input
              name="address.addr2"
              label="Address 2"
              placeholder="Address 2"
              value={location.address.addr2}
              validations={{ maxLength: 250 }}
              validationErrors={{
                maxLength: "You can not type in more than 250 characters"
              }}
            />
          </Col>
          <Col md={4} xs={4}>
            <Input
              required
              name="address.city"
              label="City"
              placeholder="City"
              value={location.address.city}
              validations={{ maxLength: 50 }}
              validationErrors={{
                maxLength: "You can not type in more than 50 characters"
              }}
            />
          </Col>
          <Col md={4} xs={4}>
            <DropdownSearch
              required
              name="address.state"
              label="State"
              value={
                this.state["address.state"] ||
                (location.address.state && location.address.state._id)
              }
              disabled={!editing}
              onChange={this.onChange}
              data={this.props.codes
                .filter(
                  (codes) => codes.entity === "*" && codes.field === "state"
                )
                .map((code) => ({
                  value: code.id,
                  label: code.label
                }))}
            />
          </Col>
          <Col md={4} xs={4}>
            <Input
              required
              name="address.zip"
              label="Zip"
              placeholder="Zip"
              value={location.address.zip}
              validations={{ maxLength: 50 }}
              validationErrors={{
                maxLength: "You can not type in more than 50 characters"
              }}
            />
          </Col>
          <Col md={4} xs={12}>
            <DropdownSearch
              required
              name="address.country"
              label="Country"
              value={this.state["address.country"] || location.address.country}
              onChange={this.onChange}
              disabled={!editing}
              data={this.props.codes
                .filter(
                  (codes) => codes.entity === "*" && codes.field === "country"
                )
                .map((code) => ({ value: code.id, label: code.label }))}
            />
          </Col>
        </Row>
        {!adding && location && location.address && (
          <Col
            md={12}
            xs={12}
            style={{ padding: 0, marginBottom: "10px", height: "30vh" }}
          >
            <Map address={location.address} />
          </Col>
        )}
        <Row>
          <Col md={12} className="footer">
            <button
              className="btn btn-cancel"
              type="button"
              onClick={this.cancel}
            >
              Cancel
            </button>
            {!adding && (
              <input
                className="btn btn-success"
                type="submit"
                disabled={
                  !this.state.canSubmit || saving || this.props.savingCustomer
                }
                value={
                  saving || this.props.savingCustomer ? "Saving... " : "Save"
                }
              />
            )}
            {adding && (
              <input
                className="btn btn-success"
                type="submit"
                disabled={
                  !this.state.canSubmit || saving || this.props.savingCustomer
                }
                value={
                  saving || this.props.savingCustomer ? "Adding... " : "Add"
                }
              />
            )}
          </Col>
        </Row>
      </Formsy>
    );
  }
}

CustomerLocationForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  codes: PropTypes.array,
  onAdd: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  editing: PropTypes.bool.isRequired,
  adding: PropTypes.bool.isRequired,
  location: PropTypes.object,
  savingCustomer: PropTypes.bool
};

CustomerLocationForm.defaultProps = {
  location: {
    name: "",
    fax: "",
    phone: "",
    address: {
      addr1: "",
      addr2: "",
      state: "",
      city: "",
      zip: "",
      country: ""
    }
  }
};

export default CustomerLocationForm;
